// extracted by mini-css-extract-plugin
module.exports = {"headingWrapper":"_4fHCIsdZ","wrapper":"_vmMifbvR"};